/**
 * Angular imports.
 */
import { Component, Input } from '@angular/core';

/**
 * Basic check box selection.
 */
@Component({
  selector: 'app-basic-check-box-select',
  templateUrl: './basic-check-box-select.component.html',
  styleUrls: ['./basic-check-box-select.component.scss']
})
export class BasicCheckBoxSelectComponent {

  /**
   * Total checkbox selected limit.
   * Suggestion list must have id, name property.
   * selected list must have id, name property.
   * Title of the selected/suggestion list.
   * No data found msg in case of search.
   * Max limit exceed error msg.
   * Search filter placeholder.
   */
  @Input() selectedLimit = 2;
  @Input() suggestionList: { id: string | number; name: string; logo: string }[] = [];
  @Input() selectedList: { id: string | number; name: string; logo: string }[] = [];
  @Input() title = '';
  @Input() noDataFoundLabel = '';
  @Input() maxLimitErrorLabel = '';
  @Input() titleErrorLabel = '';
  @Input() filterPlaceholder = '';

  /**
   * Max limit error msg to show in the DOM.
   * Filter for the search according to the name only.
   * Config for perfectScroll.
   */
  public maxLimitErrorMsg = '';
  public userFilter: { name: string } = { name: '' };
  public config = '';

  /**
   * reset search box
   */
  resetSearchBox(): void {
    this.userFilter.name = '';
  }

  /**
   * add in the selected list.
   */
  add(event, speData: { id: string | number; name: string; logo: string }): boolean {
    this.maxLimitErrorMsg = '';
    if (event.target.checked === true) {
      if (this.limitCheck()) {
        this.maxLimitErrorMsg = `${this.maxLimitErrorLabel} ${this.selectedLimit} ${this.titleErrorLabel}`;
        event.target.checked = false;
        return false;
      }
      this.selectedList.push(speData);
    } else {
      this.remove(speData);
    }
  }

  /**
   * Check the total limit.
   */
  limitCheck(): boolean {
    return this.selectedList.length + 1 > this.selectedLimit;
  }

  /**
   * check is selected or not.
   */
  isSelected(selectedData: { id: string | number; name: string }): boolean {
    const selected = this.selectedList.filter(selected => (selected.id) === (selectedData.id));
    return (selected.length > 0) ? true : false;
  }

  /**
   * remove in the selected list.
   */
  remove(speData: { id: string | number; name: string }): void {
    this.maxLimitErrorMsg = '';
    const index = this.selectedList.findIndex((item) => {
      return item.id === speData.id;
    });
    if (index != -1) {
      this.selectedList.splice(index, 1);
    }
  }
}
